<template lang="pug">
  div
    app-modal-visualizar-completo(
      v-if="showModalVisualizarProcesso && idProcesso !== null",
      @closeModal="showModalVisualizarProcesso = false",
      :idProcesso="idProcesso",
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso",
      :tipo="tipoProcesso"
    )
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clear",
        :showOs="true",
        :showMunicipios="true",
        :configuracaoFiltro="configuracaoFiltro",
        :filtroRapido="filtroRapido"
        :showFiltroDae="true"
      )
    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :showButtonAssinatura="false",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="items",
      :totalElements="totalElements",
      :pagina="filtro.pagina",
      :hasFiltroRapido="true",
      :filtro="filtro",
      @atualizarFiltro="atualizarFiltro",
      @updateListagem="initDAEVTN",
      @changePage="changePage",
      @sort="sort",
      @executar="executar",
      @selected="false"
    )
  </template>

<script>
import moment from 'moment'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto

  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('DAE_VTN'),
      items: [],
      totalElements: 0,
      showModalVisualizarProcesso: false,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      configuracaoFiltro: {
        filtroSituacaoBoleto: filtro?.filtroSituacaoBoleto?.DAE_VTN || [],
        filtroTipoPagamento: filtro?.filtroTipoPagamento?.DAE_VTN || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 4, titulo: 'Tipo de Pagamento', propriedade: 'vtnBoleto.formaPagamento', formatter: this.formatFormaPagamentoVtn, ordem: 4, acoes: [] },
        { id: 5, titulo: 'Vencimento', propriedade: 'vtnBoleto.dataVencimento', formatter: this.formatData, ordem: 5, acoes: [] },
        { id: 4, titulo: 'Situação', propriedade: 'vtnBoleto.situacao', formatter: this.formatSituacao, ordem: 6, acoes: [] },
        {
            id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Gerenciar DAE', icone: 'fa-eye', codigo: 'VISUALIZAR', ordem: 1 },
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  async created () {
    this.initDAEVTN()
  },

  watch: {
    async '$route' (to, from) {
      this.initDAEVTN()
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },

    VISUALIZAR: async (_this, { item }) => {
      _this.$router.push({
        name: 'VISUALIZAR_DAES',
        params: {
          idProcesso: item.id
        }
      })
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    formatFormaPagamentoVtn (item) {
      return item.vtnBoleto.formaPagamento === 'A_VISTA' ? 'À vista' : 'À prazo'
    },

    formatData (item) {
      return item.vtnBoleto.dataVencimento ? moment(item.vtnBoleto.dataVencimento).format('DD/MM/YYYY') : '-'
    },

    formatSituacao (item) {
      switch (item.vtnBoleto.situacao) {
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'AGUARDANDO_EMISSAO_BOLETO':
          return 'Aguardando Emissão de Boleto'
        case 'QUITADO':
          return 'Quitado'
        case 'VENCIDO':
          return 'Vencido'
        case 'CANCELADO':
          return 'Cancelado'
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .card-container {
    margin: 20px;
    border-radius: 10px;
  }
  </style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaDaeVtnListagem.vue